import React, { useContext } from "react";
import { SoundContext } from "../context/SoundContext";
import soundMute from "../assets/sound-mute.png";
import soundUnmute from "../assets/sound-unmute.png";
import styled from "styled-components";

const SoundButton = styled.img`
  width: 50px;
  height: 50px;
  cursor: pointer;
`;

const SoundToggle = () => {
  const { isMuted, setIsMuted, playSound } = useContext(SoundContext);

  const handleToggle = () => {
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    if (!newMutedState) {
      playSound("click");
    }
  };

  return (
    <SoundButton
      src={isMuted ? soundMute : soundUnmute}
      onClick={handleToggle}
      alt="Sound Toggle"
    />
  );
};

export default SoundToggle;
